module.exports = __webpack_public_path__ + "static/media/YouTube_social_white_circle.7327de0b.svg";